import React from "react";
import {Button, Modal} from "react-bootstrap";
import ModalClose from "../../../assets/modal_close.png";
import {useDispatch} from "react-redux";
import moment from "moment";
import {setCommunityGuidelinesWatchedAt} from "../../../redux/authSlice";
import {communityService} from "../../../services/communityService/communityService";

const CommunityGuidelinesModal = ({ onClose }) => {
    const dispatch = useDispatch();

    const handleSeenGuidelines = async () => {
        await communityService.confirmGuidelinesWatching();
        const currentTime = moment().format();
        dispatch(setCommunityGuidelinesWatchedAt(currentTime));
        onClose();
    }

    return (
        <>
            <Modal show="true" onHide={onClose} aria-labelledby="contained-modal-title-vcenter" centered dialogClassName="modal-90w" className="add-project-popup ">
                <Modal.Header>
                    <h3>🌟 ACTE Masterclass Series Masterclass Community Guidelines</h3>
                    <div className="modal-close" onClick={() => onClose()}>
                        <img src={ModalClose}></img>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "-webkit-fill-available", overflowY: "auto" }}>
                    <div className="row px-3">
                        <div className="guidelines-pop-up__subtitle">
                            <b>A Shared Space for Growth, Connection, and Innovation in Education</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Welcome to the ACTE Masterclass Series Masterclass Community — an interactive space designed for educators
                            and administrators who are passionate about transforming learning. Whether you're here to
                            share insights, ask questions, or explore new ideas, this community thrives on mutual
                            respect, collaboration, and a shared commitment to excellence in education.
                        </div>
                        <div className="guidelines-pop-up__subtitle mt-3">
                            <b>Our Shared Values</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            This community is built around the same core values that shape our masterclasses:
                        </div>
                        <ul className="guidelines-pop-up__text mx-3 mt-2">
                            <li className="mt-2">
                                <b>Relevance</b> – connecting classroom learning to the real world
                            </li>
                            <li className="mt-2">
                                <b>Excellence</b> – striving for instructional and operational best practices
                            </li>
                            <li className="mt-2">
                                <b>Collaboration</b> – learning from one another to drive change
                            </li>
                            <li className="mt-2">
                                <b>Equity</b> – ensuring every voice and perspective is heard and valued
                            </li>
                        </ul>
                        <div className="guidelines-pop-up__subtitle mt-3">
                            <b>What We Encourage</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>✅ Professional Respect</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Treat all members with courtesy, kindness, and professionalism. We're here to support one
                            another’s learning.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>✅ Thoughtful Contributions</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Share experiences, questions, and resources that align with the themes of our masterclasses.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>✅ Constructive Dialogue</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Engage in discussions that move the conversation forward. It’s okay to disagree — just do so
                            thoughtfully, with the goal of mutual learning.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>✅ Confidentiality & Privacy</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Respect the privacy of your students, colleagues, and institutions. Do not share sensitive
                            or personally identifiable information in the community.
                        </div>
                        <div className="guidelines-pop-up__subtitle mt-3">
                            <b>What We Do Not Allow</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>🚫 Harassment or Discrimination</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Any form of bullying, intimidation, hate speech, or exclusionary behavior will not be
                            tolerated.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>🚫 Spam or Self-Promotion</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Please keep this space focused on meaningful discussion. Avoid unsolicited promotions,
                            external sales, or irrelevant links.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            <b>🚫 Sharing Copyrighted or Proprietary Content</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Only share materials you have permission to distribute. Let’s protect intellectual property
                            and model digital citizenship.
                        </div>
                        <hr className="mt-2"/>
                        <div className="guidelines-pop-up__subtitle mt-1">
                            <b>Help Keep Our Community Strong</b>
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            We encourage all members to help us maintain a safe and productive environment. If you see
                            behavior that violates these guidelines, please report it to the ACTE Masterclass Series team at
                            info@catapultlpd.com.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Together, we can make this a space where innovation in education not only begins — but
                            flourishes.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Thank you for being part of the ACTE Masterclass Series community.
                        </div>
                        <div className="guidelines-pop-up__text mt-2">
                            Let’s keep learning, sharing, and building what’s next — together.
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        type="submit"
                        className="btn btn-primary add-btn"
                        onClick={handleSeenGuidelines}
                    >
                        Got It!
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CommunityGuidelinesModal;